import { Suspense, lazy, useEffect } from 'react';

import { ECompanyStep, usePersonalStore } from '@/entities/user';

import { ROUTES, useNavigate } from '@/shared/lib';
import { PageLoader } from '@/shared/ui';

const PublicOnlyRouteAsync = lazy(() => import('./ui/PublicOnlyRoute'));

export const PublicOnlyRoute = () => {
  const navigate = useNavigate();
  const user = usePersonalStore((state) => state.user);
  const company = usePersonalStore((state) => state.company);

  useEffect(() => {
    if (!user) return;
    if (!user.isRegistered) {
      void navigate(ROUTES.REGISTRATION);
      return;
    }

    if (
      !company?.step ||
      company.step !== ECompanyStep.CompanyOnboardingCompleted
    ) {
      void navigate(ROUTES.KYB_QUESTIONNAIRE, { replace: true });
      return;
    }

    void navigate(ROUTES.ROOT);
  }, [user]);

  if (localStorage.getItem('@accessToken') && user) return null;
  return (
    <Suspense fallback={<PageLoader />}>
      <PublicOnlyRouteAsync />
    </Suspense>
  );
};
